import React, { useEffect, useCallback } from "react";
import { withStyles } from "@mui/styles";

import { withState } from "../../../services/state";
import {
  getAdjustmentReasons as apiGetAdjustmentReasons,
  createAdjustmentReason as apiCreateAdjustmentReason,
  updateAdjustmentReason as apiUpdateAdjustmentReason,
} from "../../../services/api";

import PageWrapper from "../../components/pageWrapper/PageWrapper";
import DialogModal from "../../components/dialogModal/DialogModal";
import Section from "../../components/section/Section";

import AdjustmentReasonsTable from "../../tables/adjustmentReasonsTable/AdjustmentReasonsTable";
import AddAdjustmentReasonForm from "../../forms/addAdjustmentReasonForm/AddAdjustmentReasonForm";
import EditAdjustmentReasonForm from "../../forms/editAdjustmentReasonForm/EditAdjustmentReasonForm";

const styles = (theme) => ({
  root: {
    width: "100%",
  },
});

function AdjustmentReasonsPage({ context }) {
  const [showAddAdjustmentReason, toggleShowAddAdjustmentReason] =
    React.useState(false);
  const [newAdjustmentReason, storeNewAdjustmentReason] = React.useState(false);
  const [adjustmentReasons, setAdjustmentReasons] = React.useState([]);
  // const [gettingAdjustmentReasons, setGettingAdjustmentReasons] = React.useState(false);
  const [creatingAdjustmentReason, setCreatingAdjustmentReason] =
    React.useState(false);
  const [createAdjustmentReasonError, setCreateAdjustmentReasonError] =
    React.useState("");
  const [editAdjustmentReason, setEditAdjustmentReason] = React.useState(null);
  const [updatingAdjustmentReason, setUpdatingAdjustmentReason] =
    React.useState(false);
  const [updateAdjustmentReasonError, setUpdateAdjustmentReasonError] =
    React.useState("");

  const getAdjustmentReasons = useCallback(async () => {
    if (
      !context.currentClub ||
      !context.currentClub.clubId ||
      !context.currentPlayer ||
      !context.currentPlayer.id
    ) {
      return false;
    }

    try {
      // setGettingAdjustmentReasons(true);
      const data = await apiGetAdjustmentReasons(context.currentClub.clubId);
      if (data && !data.reason) {
        setAdjustmentReasons(data);
      }
      // setGettingAdjustmentReasons(false);
    } catch (e) {
      console.log(e);
      // setGettingAdjustmentReasons(false);
    }
  }, [context.currentClub, context.currentPlayer]);

  const createAdjustmentReason = async (payload) => {
    if (!payload.reason) {
      return setCreateAdjustmentReasonError("Please enter a reason");
    }

    setCreateAdjustmentReasonError("");

    try {
      setCreatingAdjustmentReason(true);
      await apiCreateAdjustmentReason(context.currentClub.clubId, {
        reason: payload.reason,
      });
      setCreatingAdjustmentReason(false);
      toggleShowAddAdjustmentReason(false);
      getAdjustmentReasons();
    } catch (e) {
      setCreatingAdjustmentReason(false);
      setCreateAdjustmentReasonError(e.message);
    }
  };

  const updateAdjustmentReason = async (payload) => {
    if (!payload.reason) {
      return setUpdateAdjustmentReasonError("Please enter a reason");
    }

    setUpdateAdjustmentReasonError("");

    try {
      setUpdatingAdjustmentReason(true);
      await apiUpdateAdjustmentReason(
        context.currentClub.clubId,
        payload.id,
        payload
      );
      setEditAdjustmentReason(null);
      setUpdatingAdjustmentReason(false);
      getAdjustmentReasons();
    } catch (e) {
      setUpdatingAdjustmentReason(false);
      setUpdateAdjustmentReasonError(e.message);
    }
  };

  useEffect(() => {
    getAdjustmentReasons();
  }, [getAdjustmentReasons]);

  return (
    <PageWrapper
      showHeader={true}
      showSidebar={true}
      title="Adjustment reasons"
    >
      <Section>
        <AdjustmentReasonsTable
          adjustmentReasons={adjustmentReasons}
          addButtonText="Add adjustment reason"
          onAddButtonClick={() => {
            toggleShowAddAdjustmentReason(true);
            storeNewAdjustmentReason({});
          }}
          onEditAdjustmentReason={(adjustmentReason) =>
            setEditAdjustmentReason(adjustmentReason)
          }
        />
      </Section>

      {showAddAdjustmentReason && (
        <DialogModal
          submitText="Add"
          onSubmit={() => createAdjustmentReason(newAdjustmentReason)}
          onClose={() => toggleShowAddAdjustmentReason(false)}
          error
          submitting={creatingAdjustmentReason}
        >
          <AddAdjustmentReasonForm
            payload={newAdjustmentReason}
            storePayload={(payload) => storeNewAdjustmentReason(payload)}
            errorMessage={createAdjustmentReasonError}
          />
        </DialogModal>
      )}

      {editAdjustmentReason && (
        <DialogModal
          title="Edit adjustment reason"
          submitText="Update"
          onSubmit={() => updateAdjustmentReason(editAdjustmentReason)}
          onClose={() => setEditAdjustmentReason(null)}
          error
          submitting={updatingAdjustmentReason}
        >
          <EditAdjustmentReasonForm
            payload={editAdjustmentReason}
            storePayload={(payload) => setEditAdjustmentReason(payload)}
            errorMessage={updateAdjustmentReasonError}
          />
        </DialogModal>
      )}
    </PageWrapper>
  );
}

export default withStyles(styles)(withState(AdjustmentReasonsPage));
